import React from 'react';
import { Button } from '@starrez/starryui9';
import { useSelectionOption } from './Context';
import { useManagedDropdown } from '../../ManagedDropdown/ManagedDropdown';

interface IOptionGhostButtonProps {
    caption: string;
    onClick: () => void;
}

export const OptionGhostButton = ({ caption, onClick }: IOptionGhostButtonProps) => {
    const { onItemClick } = useSelectionOption();
    const { closeDropdown } = useManagedDropdown();

    const handleOnItemClick = () => {
        onItemClick({ name: 'OptionGhostButton', caption });
        closeDropdown();
        onClick();
    };

    return (
        <li>
            <Button onClick={handleOnItemClick} fullWidth variant="Ghost" type="button">
                {caption}
            </Button>
        </li>
    );
};
